import { NavColors, NavColor } from "./NavColors";

/**
 * Navigation group information.
 */
export interface NavGroupInfo {
  /**
   * The navigation group name.
   */
  readonly name: string;

  /**
   * The navigation group color.
   */
  readonly color: NavColor | NavColors;

  /**
   * The group order.
   */
  readonly order: number;
}

/**
 * The core adjudication group.
 */
export const CoreAdjudicationGroup: NavGroupInfo = { name: "Core Adjudication", color: NavColors.turquoise, order: 0 };

/**
 * The operations group.
 */
export const OperationsGroup: NavGroupInfo = { name: "Operations", color: NavColors.darkblue, order: 1 };

/**
 * The financial group.
 */
export const FinancialGroup: NavGroupInfo = { name: "Financial", color: NavColors.green, order: 2 };

/**
 * The clinical group.
 */
export const ClinicalGroup: NavGroupInfo = { name: "Clinical", color: NavColors.purple, order: 3 };

/**
 * The government group.
 */
export const GovernmentGroup: NavGroupInfo = { name: "Government", color: NavColors.yellow, order: 4 };

/**
 * The data and reporting group.
 */
export const DataAndReportingGroup: NavGroupInfo = { name: "Data & Reporting", color: NavColors.orange, order: 5 };

/**
 * The admin group.
 */
export const AdminGroup: NavGroupInfo = { name: "Admin", color: NavColors.red, order: 6 };

/**
 * Third Party Administrator group.
 */
export const TPAGroup: NavGroupInfo = { name: "TPA Eligibility & Billing", color: NavColors.darkgreen, order: 7 };
